export default "__VITE_ASSET__DB4Vnu9N__"